module.exports = __webpack_public_path__ + "static/media/pago.581ecd79.png";